import { Layout, Typography } from "antd";
import { AuthForm } from "features/auth";
import { useTranslation } from "react-i18next";
import { AuthHeader } from "widgets/headers";

export const LoginPage = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <AuthHeader />
      <Layout.Content
        style={{
          paddingTop: "6vh",
        }}
        className="auth-layout-content"
      >
        <div
          style={{
            fontFamily: 'font-family: "Syne", sans-serif',
            fontSize: 28,
            fontWeight: 800,
            letterSpacing: -0.5,
            color: "#FB0090",
            textAlign: "center",
            margin: 32,
          }}
        >
          AKJET
        </div>
        <AuthForm />
        <Typography.Text style={{ marginTop: 16, display: "block" }}>
          {t("auth.agree_to_terms")}{" "}
          <a
            href="https://akjet.kz/assets/user_agreement.pdf?v=1"
            target="_blank"
            rel="noreferrer"
          >
            {t("auth.user_agreement")}
          </a>
        </Typography.Text>
      </Layout.Content>
    </Layout>
  );
};
